







































import Vue from 'vue'
import AuctionBGeneratePDFs from '@/UI/AuctionB/AuctionBGeneratePDFs.vue'
import { SweetAlertResult } from 'sweetalert2'

// Modal
import VModal from 'vue-js-modal'
Vue.use(VModal)

export default Vue.extend({
  name: 'AuctionBModals',
  components: { AuctionBGeneratePDFs },
  props:
  {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      filesDownloaded: false
    }
  },
  methods: {
    hide () {
      if (!this.filesDownloaded) {
        this.$swal({
          title: this.$t('shared.atencion').toString(),
          text: this.$t('subastaB.modal.warningDeleteFiles').toString(),
          icon: 'warning',
          showCancelButton: true,
          width: 400
        }).then((result: SweetAlertResult) => {
          if (result.value) {
            this.$modal.hide('pdfsModal')
            this.openUrl()
          }
        })
      } else {
        this.$modal.hide('pdfsModal')
        this.openUrl()
      }
    },
    openUrl () {
      this.$emit('deleteVuex')
      if (this.url !== '') { window.open(this.url, '_blank') }
      this.$router.push({ name: 'Home' })
    }
  }
})
